import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/img/defaultprofile.jpg'


const _withScopeId = n => (_pushScopeId("data-v-3ee97458"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_upperAnchor" }, null, -1))
const _hoisted_2 = { class: "_nodeImage" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  src: _imports_0,
  key: "def"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "_nodeBody" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-cyan" }, "Qualifica:", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-cyan" }, "Punti:", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-cyan" }, "Clienti: ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-cyan" }, "Ref: ", -1))
const _hoisted_13 = { class: "_nodeFooter" }
const _hoisted_14 = { class: "filter" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-10" }, "Mostra lead", -1))
const _hoisted_16 = { class: "filter ml-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-10" }, "Mostra clienti", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _component_toggler = _resolveComponent("toggler")!
  const _component_node = _resolveComponent("node", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: "_nodeContainer",
    style: _normalizeStyle(_ctx.node.offset)
  }, [
    _hoisted_1,
    _createElementVNode("div", {
      class: _normalizeClass(["_node", _ctx.node.role]),
      onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onNodeClick && _ctx.onNodeClick(...args)), ["stop","prevent"]))
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.node.imageUrl)
            ? (_openBlock(), _createElementBlock("img", {
                src: _ctx.node.imageUrl,
                key: "img"
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("img", _hoisted_4)),
          _createElementVNode("div", {
            class: _normalizeClass(["_nodeImageText", { 'text-orange': _ctx.node.role == 'Cliente' || _ctx.node.role == 'Lead', 'text-green': _ctx.node.role == 'Collaboratore' }])
          }, [
            _createTextVNode(_toDisplayString(_ctx.node.role) + " ", 1),
            (_ctx.node.nonFumatore)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "non fumatore"))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, _toDisplayString(_ctx.node.username), 1),
          _createElementVNode("div", null, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("b", null, _toDisplayString(_ctx.node.qualifica ? _ctx.node.qualifica.codiceQualifica : ''), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("b", null, _toDisplayString(_ctx.node.puntiReteMaturati), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_11,
            _createElementVNode("b", null, _toDisplayString(_ctx.node.totaleClienti), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_12,
            _createElementVNode("b", null, _toDisplayString(_ctx.node.referralCode), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
          : (_ctx.showFilters)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_toggler, {
                      class: "mini",
                      modelValue: _ctx.showLead,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showLead) = $event)),
                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"]))
                    }, null, 8, ["modelValue"])
                  ]),
                  _hoisted_15
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_toggler, {
                      class: "mini",
                      modelValue: _ctx.showClienti,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showClienti) = $event)),
                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop","prevent"]))
                    }, null, 8, ["modelValue"])
                  ]),
                  _hoisted_17
                ])
              ], 64))
            : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["_nodeChildren", { _shown: _ctx.children.length > 0 }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (item, i) => {
        return (_openBlock(), _createBlock(_component_node, {
          isCommerciale: _ctx.isCommerciale,
          key: i,
          node: item,
          class: _normalizeClass({ 'disabled': item.hide, '_singleNode': _ctx.children.length == 1 }),
          showClienti: _ctx.showClienti,
          showLead: _ctx.showLead,
          showFilters: _ctx.showFilters,
          onClosed: _ctx.showSiblings,
          onOpened: ($event: any) => (_ctx.hideSiblings(item)),
          allowNavigation: _ctx.allowNavigation
        }, null, 8, ["isCommerciale", "node", "class", "showClienti", "showLead", "showFilters", "onClosed", "onOpened", "allowNavigation"]))
      }), 128))
    ], 2)
  ], 4))
}